export function getCurrentPathId() {
    const path = window.location.pathname
    return path.split('/').reverse()[0]
}

export function removeIdFromPath() {
    const path = window.location.pathname
    const parsed = path.split('/')
    return parsed.slice(0, parsed.length - 2).join('/')
}